import { EventEmitter } from 'events';
import { FilterMatch, FilterType, SavedFilter } from 'src/app/components/dialogs/select-filter-new/models/saved-filter';
import { BuiltInFieldId } from 'src/app/models/built-in-field-id.enum';
import { FieldDisplayType } from 'src/app/components/dialogs/select-filter-new/models/field-display-type';
import { FilterComparerGuids } from 'src/app/components/dialogs/select-filter-new/models/filter-comparer-guids';
import { DocSdk } from '../../sdks/doc.sdk';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class TextGroupManager {
	public onGroupChange: EventEmitter = new EventEmitter();
	public active = false;
	public currentGroupIndex: number;
	public totalTextGroups: number;
	public readonly groupChangeEventName = 'group-change';
	private groups: string[];

	constructor(private docSdk: DocSdk) {
	}

	public initialize(textGroupId: number) {
		this.docSdk.getNearDupTextGroupings(0, 0).subscribe((groups) => {
			this.totalTextGroups = groups.totalItems;
			this.groups = groups.items.map((data) => data.textGroupId.toString());
			this.currentGroupIndex = this.groups.indexOf(textGroupId.toString());

			if (this.currentGroupIndex === -1) {
				console.error(`Could not find group ID '${textGroupId}' in groups '${this.groups}'`);
				return;
			}
			this.active = true;
		});
	}

	public moveNext() {
		if (this.active && this.currentGroupIndex < this.totalTextGroups - 1) {
			++this.currentGroupIndex;
			this.onGroupChange.emit(this.groupChangeEventName, this.groups[this.currentGroupIndex], this.createTextGroupIdFilter(this.groups[this.currentGroupIndex]));
		}
	}

	public movePrev() {
		if (this.active && this.currentGroupIndex > 0) {
			--this.currentGroupIndex;
			this.onGroupChange.emit(this.groupChangeEventName, this.groups[this.currentGroupIndex], this.createTextGroupIdFilter(this.groups[this.currentGroupIndex]));
		}
	}

	public clear() {
		this.active = false;
		this.totalTextGroups = 0
		this.groups = [];
		this.currentGroupIndex = -1;
	}

	private createTextGroupIdFilter(textGroupId: string): SavedFilter {
		return {
			type: FilterType.Simple,
			match: FilterMatch.All,
			not: false,
			fields: [{
				fieldId: BuiltInFieldId.TextGroupId,
				displayType: FieldDisplayType.Text,
				comparer: FilterComparerGuids.Is,
				value: [textGroupId]
			}]
		};
	}
}
